import { render } from "./AdsibInformation.vue?vue&type=template&id=0488acd7&ts=true"
import script from "./AdsibInformation.vue?vue&type=script&lang=ts"
export * from "./AdsibInformation.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__